import LandingPage from './landing'

export default LandingPage